'use client'

import React from 'react'
import { motion } from 'framer-motion'
import { User } from 'lucide-react'
import { VerifiedCheckBold } from 'solar-icons'
import { cn } from '@/lib/utils'

import { Avatar, AvatarFallback, BackButton, Skeleton } from '@/components/ui'

const variants = {
  animateProfile: {
    width: '50vw',
  },
}

interface SelectedUserProps extends React.ComponentPropsWithoutRef<'div'> {
  user: {
    id: string
    name: string
  }
  location: {
    id: string
    name: string
  }
}

export const SelectedUser = ({
  className,
  user,
  location,
}: SelectedUserProps) => {
  return (
    <motion.div
      className={cn(
        'hidden w-[100vw] shrink-0 items-center justify-center lg:flex',
        className,
      )}
      variants={variants}
      animate="animateProfile"
    >
      <div className="flex size-full flex-col items-center justify-center gap-9 pb-[10dvh]">
        <Avatar className="relative size-[100px] overflow-visible bg-white p-1 shadow-md">
          <AvatarFallback className="border border-gray-100 bg-gray-50 text-2xl text-gray-400 dark:border-gray-700">
            <User className="size-10" strokeWidth={1.5} />
          </AvatarFallback>
          <VerifiedCheckBold className="absolute bottom-1 right-1 text-blue-600" />
        </Avatar>

        <div className="flex flex-col items-center gap-3 text-center">
          <h2 className="text-4xl font-bold">{user?.name}</h2>
          <span className="font-medium text-gray-950">{location?.name}</span>
        </div>

        <BackButton className="pr-[22px]">Back</BackButton>
      </div>
    </motion.div>
  )
}

export const SelectedUserSkeleton = () => {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-9 pb-[10dvh]">
      <Skeleton className="size-[100px] rounded-full" />
      <div className="flex flex-col items-center gap-3 text-center">
        <Skeleton className="h-[16px] w-[200px] rounded-full" />
        <Skeleton className="h-[12px] w-[120px] rounded-full" />
      </div>

      <Skeleton className="h-[40px] w-[112px] rounded-md" />
    </div>
  )
}
